import {useState} from 'react';

export const MEDIA_LIBRARY_TABS = {
  GROUP_IMAGES: 'GROUP_IMAGES',
  EDUME_IMAGES: 'EDUME_IMAGES',
  GROUP_VIDEOS: 'GROUP_VIDEOS',
  EXTERNAL_VIDEOS: 'EXTERNAL_VIDEOS',
  UPLOAD_TOOLS: 'UPLOAD_TOOLS',
} as const;

export type LibraryTab =
  (typeof MEDIA_LIBRARY_TABS)[keyof typeof MEDIA_LIBRARY_TABS];

export const useMediaLibraryTab = (initialTab: LibraryTab) =>
  useState<LibraryTab>(initialTab);

export type LibraryTabState = ReturnType<typeof useMediaLibraryTab>[0];
export type LibraryTabStateSetter = ReturnType<typeof useMediaLibraryTab>[1];
